import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { red } from '@material-ui/core/colors';
import Iframe from 'react-iframe';
import { Close } from '@material-ui/icons';

import { Icon } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
  techGptHideWrapper: {
    color: '#000',
    position: 'absolute',
    right: '5px',
    top: '-20px',
    paddingRight: '5px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    border: '1px solid #ccc',
    paddingLeft: '5px',
    paddingTop: '5px'
  },
  techGptContainer: {
    right: '0',
    width: '40%',
    '@media (max-width: 999px)': {
      width: '100%'
    },
    bottom: 'auto',
    height: '80vh',
    zIndex: 9999,
    position: 'fixed',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    transition: 'top 0.5s ease-out'

  },
  techGptHide: {
    fontSize: '30px',
    cursor: 'pointer'
  }

}));
const TechGptWidget = ({ closeToggle }) => {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  TechGptWidget.propTypes = {
    closeToggle: closeToggle.isRequired
  };
  return (
    <div className={classes.techGptContainer}>
      <div className={classes.techGptHideWrapper}>
        <Close
          className={classes.techGptHide}
          onClick={() => {
            closeToggle();
          }}
        />
      </div>
      <Iframe
        url="https://techgpt.beko.com/?iframe=true&lang=en-US&menu=false"
        width="100%"
        id="techGptIframe"
        height="100%"
        frameBorder={0}
        loading="Loading.."
      />
    </div>
  );
};

export default TechGptWidget;
